import { Injectable } from '@angular/core';
import { Action, Selector, State, type StateContext } from '@ngxs/store';
import * as FlatModels from '@medsurf/flat-models';
import { BookmarkAuthorActions } from '@medsurf/flat-actions';

export interface BookmarkAuthorStateModel {
  bookmarks: { [id: string]: FlatModels.BookmarkAuthorModels.SlideBookmark }
}

@State<BookmarkAuthorStateModel>({
  name: 'bookmarkAuthor',
  defaults: {
    bookmarks: {}
  }
})
@Injectable()
export class BookmarkAuthorState {
  //<editor-fold desc="Selectors">

  @Selector([BookmarkAuthorState])
  static bookmarks$(state: BookmarkAuthorStateModel) {
    return state.bookmarks;
  }

  @Selector([BookmarkAuthorState.bookmarks$])
  static nodeBookmarked$(bookmarks: { [id: string]: FlatModels.BookmarkAuthorModels.SlideBookmark }) {
    return (id: string) => {
      return bookmarks && bookmarks[id] ? true : false;
    }
  }

  //</editor-fold>

  //<editor-fold desc="Actions">

  @Action(BookmarkAuthorActions.ToggleNode)
  toggleNode({getState, patchState}: StateContext<BookmarkAuthorStateModel>,
             {node, page}: BookmarkAuthorActions.ToggleNode) {
    // Get Bookmarks
    const bookmarks = structuredClone(getState().bookmarks);

    // Update Nodes
    if (bookmarks[node.id]) {
      delete bookmarks[node.id];
    } else {
      bookmarks[node.id] = {
        id: node.id,
        title: page.title
      };
    }

    // Patch State
    patchState({
      bookmarks
    });
  }

  //</editor-fold>
}
